export default __webpack_public_path__ + "static/lipetsk-5bd422e8a80ef07867fe78b50bd27927.jpg";